import AboutSecondImage from "../svg/AboutSecondImg.svg"
const AboutPic = () => {
    return (
   
  <img src={AboutSecondImage} style={{width:"100%"}}/>


    )
  }
  export default AboutPic;